import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { PRODUCTS } from './MetaPixel';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Lucas M.',
    location: 'Mendoza',
    product: 'Megapack + Potenciadores',
    text: 'Antes llegaba al lunes sin saber qué publicar. Ahora copio el copy del banco, lo pego y el WhatsApp empieza a sonar.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'La Plata',
    product: 'Megapack Barbero Pro',
    text: 'Mis clientes me preguntan si contraté a alguien para manejar el Instagram. Lo hago yo solo con los templates.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'VR',
    name: 'Valentín R.',
    location: 'Santa Fe',
    product: 'Upselling Barbero',
    text: 'En 4 semanas el ticket promedio subió un 35%. Solo con el sistema de upselling del Volumen 1.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Neuquén',
    product: 'Meta Ads Barbero',
    text: 'Lancé el primer anuncio el martes. El miércoles ya tenía 3 turnos nuevos. $1 USD invertido.',
    bg: 'bg-brandOrange'
  }];
  return <Section className="bg-bg-base" data-id="element-205">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-206">
        <h2 className="font-display font-normal md:text-[48px] text-txt-primary mb-3 md:mb-4 text-[36px]" data-id="element-207">
          Lo que dicen <span className="text-brandOrange" data-id="element-208">los barberos</span>
        </h2>
        <div className="inline-flex items-center gap-2" data-id="element-209">
          <span className="font-sans font-medium text-brandOrange text-[15px] md:text-[16px]" data-id="element-210">
            4.9/5
          </span>
          <span className="text-brandOrange" data-id="element-211">·</span>
          <span className="font-sans text-brandOrange text-[15px] md:text-[16px]" data-id="element-212">
            +500 barberos en Latinoamérica
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-213">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-214">
            <div className="bg-bg-card p-5 md:p-6 rounded-[16px] border border-brandOrange/30 h-full flex flex-col" data-id="element-215">
              <div className="flex items-center gap-3 mb-4" data-id="element-216">
                <div className={`w-12 h-12 ${t.bg} text-black rounded-full flex items-center justify-center font-sans font-bold text-sm shrink-0`} data-id="element-217">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-218">
                  <p className="font-sans font-bold text-txt-primary text-[15px] md:text-[16px] leading-tight mb-1" data-id="element-219">
                    {t.name}
                  </p>
                  <p className="text-[13px] font-sans text-txt-muted" data-id="element-220">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-primary font-quote italic text-[16px] md:text-[18px] leading-[1.6] mb-5" data-id="element-221">
                "{t.text}"
              </p>
              <div className="mt-auto" data-id="element-222">
                <span className="inline-block bg-bg-highlight text-txt-muted font-sans font-bold uppercase tracking-[0.5px] text-[10px] md:text-[11px] px-2.5 py-1 rounded" data-id="element-223">
                  {t.product}
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-card border-2 border-success" data-id="element-224">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-225">
        <div className="py-8 md:py-10" data-id="element-226">
          <ShieldCheck size={80} className="mx-auto text-success mb-6 relative z-10" data-id="element-227" />
          <h2 className="font-display font-normal text-[36px] md:text-[52px] leading-[1.1] text-txt-primary mb-6 relative z-10" data-id="element-228">
            GARANTÍA 15 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[16px] md:text-[18px] leading-[1.6] md:leading-[1.7] text-txt-primary opacity-80 space-y-2 mb-8 relative z-10" data-id="element-229">
            <p data-id="element-230">Abrís los niveles. Los usás en tu negocio.</p>
            <p data-id="element-231">Si en 15 días no es lo que esperabas:</p>
            <p data-id="element-232">devolución del 100%.</p>
            <p data-id="element-233">Sin formularios. Sin drama. Sin vueltas.</p>
          </div>
          <p className="font-sans text-[15px] md:text-[16px] text-brandOrange relative z-10" data-id="element-234">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si recién empiezo como barbero?',
    a: 'Sí. El Nivel 1 empieza desde la mentalidad y la identidad. No importa si tenés 3 meses o 3 años. El sistema funciona para quien recién arranca y para quien quiere escalar lo que ya tiene.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'El acceso llega a tu email en menos de 5 minutos después del pago. Descargás los PDFs directamente. Sin aplicaciones, sin claves, sin esperas. Todo en tu celular o computadora desde el primer momento.'
  }, {
    q: '¿Necesito invertir mucho en publicidad para que funcione?',
    a: 'No. El sistema está diseñado para funcionar con $1 USD por día en Meta Ads. El Nivel 3 explica exactamente cómo configurar la campaña de mensajes con presupuesto mínimo y resultado máximo.'
  }, {
    q: '¿Funciona si no tengo muchos seguidores en Instagram?',
    a: 'Completamente. El sistema no depende de seguidores ni de Reels virales. Depende de anuncios pagos locales que llegan directamente a hombres del barrio. El Bono 6 además enseña cómo crecer en Instagram sin depender del algoritmo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 15 días de garantía total. Si abrís el material y no es lo que esperabas, escribís a soportecentershop95@gmail.com y te devolvemos el 100% sin preguntas ni formularios.'
  }, {
    q: '¿Los Potenciadores se pueden usar junto al Megapack?',
    a: 'Sí, están diseñados para usarse en paralelo. El Megapack resuelve el problema base de llenar la agenda. Los Potenciadores agregan las capas de upselling, Google Maps, finanzas, video y sistema de equipo que llevan la barbería al siguiente nivel.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-base" data-id="element-235">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-236">
        <h2 className="font-display font-normal text-[36px] md:text-[52px] leading-[1.1] text-txt-primary text-center mb-8 md:mb-10" data-id="element-237">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-238">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-brandOrange/30 rounded-[12px] overflow-hidden transition-colors`} data-id="element-239">
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-240">
                <span className="font-sans font-bold text-[15px] md:text-[17px] text-txt-primary" data-id="element-241">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandOrange shrink-0" size={20} data-id="element-242" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-243" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[15px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-primary opacity-80 border-t border-line pt-4" data-id="element-244">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: 'Miércoles y jueves con la silla vacía',
    costo: 'Ingresos perdidos cada semana'
  }, {
    sin: 'Anuncios sin sistema que no convierten',
    costo: 'Plata gastada en publicidad que no funciona'
  }, {
    sin: 'WhatsApp sin guion, clientes que se enfrían',
    costo: 'Turnos que se pierden en la conversación'
  }, {
    sin: 'Sin upselling: cobrás siempre lo mismo',
    costo: 'Ticket estancado aunque trabajes más'
  }, {
    sin: 'Agenda reactiva: llena el viernes, vacía el martes',
    costo: 'Stress y facturación impredecible'
  }, {
    sin: 'Domingo buscando qué publicar',
    costo: 'El mismo ciclo, el mismo año'
  }];
  return <Section className="bg-bg-card" data-id="element-245">
      <FadeIn className="max-w-4xl mx-auto" data-id="element-246">
        <h2 className="font-display font-normal md:text-[52px] text-center mb-8 md:mb-12 text-txt-primary text-[36px]" data-id="element-247">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="mb-10 md:mb-12" data-id="element-248">
          <div className="grid grid-cols-2 gap-4 md:gap-8 mb-6 px-4" data-id="element-249">
            <div className="font-sans font-bold text-[15px] md:text-[16px] text-danger" data-id="element-250">
              Sin el Megapack
            </div>
            <div className="font-sans font-bold text-[15px] md:text-[16px] text-brandOrange" data-id="element-251">
              Costo real
            </div>
          </div>
          <div className="space-y-4 md:space-y-5 px-4" data-id="element-252">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 md:gap-8 items-center" data-id="element-253">
                <div className="font-sans text-[14px] md:text-[16px] leading-[1.4] md:leading-[1.5] text-txt-primary opacity-80" data-id="element-254">
                  {row.sin}
                </div>
                <div className="font-sans text-[14px] md:text-[16px] leading-[1.4] md:leading-[1.5] text-txt-primary flex items-start gap-2" data-id="element-255">
                  <span className="text-brandOrange" data-id="element-256">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="bg-bg-base border-l-4 border-brandOrange p-6 md:p-8" data-id="element-257">
          <p className="font-sans font-bold text-[16px] md:text-[18px] text-txt-primary mb-2" data-id="element-258">
            El próximo lunes puede ser diferente...
          </p>
          <p className="font-sans text-[15px] md:text-[17px] text-txt-primary opacity-80 mb-4" data-id="element-259">
            Podés seguir publicando sin sistema,
            <br data-id="element-260" />o entrar con los anuncios, los scripts y la agenda resuelta.
          </p>
          <p className="font-sans font-bold text-[16px] md:text-[18px] text-brandOrange" data-id="element-261">
            Vos decidís.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
const FinalCTAOffers = () => {
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  return <div className="max-w-xl mx-auto flex flex-col gap-5 md:gap-6 mb-10 md:mb-12" data-id="element-262">
      {/* Basic option */}
      <div role="button" tabIndex={0} onClick={() => setSelected('basic')} onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setSelected('basic');
      }
    }} aria-pressed={selected === 'basic'} className={`relative rounded-[16px] md:rounded-[20px] p-5 md:p-7 border-2 cursor-pointer transition-all bg-bg-card text-left ${selected === 'basic' ? 'border-brandOrange shadow-[0_0_40px_rgba(240,188,76,0.25)]' : 'border-line opacity-90'}`} data-id="element-263">
        <div className="flex items-center gap-2.5 mb-2" data-id="element-264">
          <span className="text-[22px] md:text-[26px] leading-none" data-id="element-265">📘</span>
          <h4 className="font-sans font-extrabold uppercase tracking-[0.5px] text-txt-primary text-[18px] md:text-[22px] leading-[1.1]" data-id="element-266">
            MEGAPACK FUNCIONAL 365
          </h4>
        </div>

        <p className="font-sans text-[14px] md:text-[16px] text-txt-primary opacity-80 mb-4 md:mb-5" data-id="element-267">
          6 Tomos + 6 Bonos · 365 sesiones
        </p>

        <p className="font-sans text-[15px] md:text-[18px] line-through text-danger leading-tight mb-1" data-id="element-268">
          $34.990
        </p>
        <p className={`font-display font-black text-[40px] md:text-[52px] leading-none mb-4 md:mb-5 transition-colors ${selected === 'basic' ? 'text-brandOrange' : 'text-txt-primary'}`} data-id="element-269">
          $19.990
        </p>

        <CTAButton href={PRODUCTS.basic.checkoutUrl} fullWidth trackingProduct="basic" onClick={e => e.stopPropagation()} className={selected === 'basic' ? '!py-4 !text-[15px] md:!text-[17px]' : '!bg-transparent !text-txt-primary !border !border-line !shadow-none hover:!bg-bg-highlight !animate-none !py-4 !text-[15px] md:!text-[17px]'} data-id="element-270">
          QUIERO EL MEGAPACK
        </CTAButton>
      </div>

      {/* Plus option — with MÁS ELEGIDO pill */}
      <div className="relative pt-3" data-id="element-271">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-brandOrange text-black font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] px-4 py-1 rounded-full whitespace-nowrap z-10 shadow-md" data-id="element-272">
          ⭐ MÁS ELEGIDO
        </div>

        <div role="button" tabIndex={0} onClick={() => setSelected('plus')} onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setSelected('plus');
        }
      }} aria-pressed={selected === 'plus'} className={`relative rounded-[16px] md:rounded-[20px] p-5 md:p-7 border-2 cursor-pointer transition-all bg-bg-card text-left ${selected === 'plus' ? 'border-brandOrange shadow-[0_0_40px_rgba(240,188,76,0.25)]' : 'border-line opacity-90'}`} data-id="element-273">
          <div className="flex items-center gap-2.5 mb-2" data-id="element-274">
            <span className="text-[22px] md:text-[26px] leading-none" data-id="element-275">🏆</span>
            <h4 className="font-sans font-extrabold uppercase tracking-[0.5px] text-txt-primary text-[18px] md:text-[22px] leading-[1.1]" data-id="element-276">
              MEGAPACK + POTENCIADORES
            </h4>
          </div>

          <p className="font-sans text-[14px] md:text-[16px] text-txt-primary opacity-80 mb-4 md:mb-5" data-id="element-277">
            6 Tomos + 6 Bonos + 6 Potenciadores
          </p>

          <p className="font-sans text-[15px] md:text-[18px] line-through text-danger leading-tight mb-1" data-id="element-278">
            $49.990
          </p>
          <p className={`font-display font-black text-[40px] md:text-[52px] leading-none mb-4 md:mb-5 transition-colors ${selected === 'plus' ? 'text-brandOrange' : 'text-txt-primary'}`} data-id="element-279">
            $27.990
          </p>

          <CTAButton href={PRODUCTS.plus.checkoutUrl} fullWidth trackingProduct="plus" onClick={e => e.stopPropagation()} className={selected === 'plus' ? '!py-4 !text-[15px] md:!text-[17px]' : '!bg-transparent !text-txt-primary !border !border-line !shadow-none hover:!bg-bg-highlight !animate-none !py-4 !text-[15px] md:!text-[17px]'} data-id="element-280">
            QUIERO EL SISTEMA COMPLETO
          </CTAButton>
        </div>
      </div>
    </div>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-bg-base border-t-2 border-brandOrange pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-281">
      <FadeIn className="max-w-[800px] mx-auto text-center" data-id="element-282">
        <div className="mb-10 md:mb-12" data-id="element-283">
          <div className="inline-flex items-center gap-1.5 bg-danger/15 border border-danger/40 text-danger font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 rounded-full mb-4 animate-pulse" data-id="element-284">
            <span className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" data-id="element-285"></span>
            🚨 ÚLTIMA OPORTUNIDAD
          </div>
          <h3 className="font-display font-normal text-[36px] md:text-[44px] text-txt-primary mb-4" data-id="element-286">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="flex justify-center gap-3 md:gap-5 text-brandOrange mb-4" data-id="element-287">
            <div className="bg-bg-card w-[70px] h-[80px] md:w-[90px] md:h-[100px] flex flex-col items-center justify-center rounded-[12px]" data-id="element-288">
              <span className="font-display font-normal text-[40px] md:text-[72px] leading-none" data-id="element-289">
                {hours.toString().padStart(2, '0')}
              </span>
              <span className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1" data-id="element-290">
                hs
              </span>
            </div>
            <div className="font-display font-normal text-[40px] md:text-[72px] py-1 flex items-center" data-id="element-291">
              :
            </div>
            <div className="bg-bg-card w-[70px] h-[80px] md:w-[90px] md:h-[100px] flex flex-col items-center justify-center rounded-[12px]" data-id="element-292">
              <span className="font-display font-normal text-[40px] md:text-[72px] leading-none" data-id="element-293">
                {minutes.toString().padStart(2, '0')}
              </span>
              <span className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1" data-id="element-294">
                min
              </span>
            </div>
            <div className="font-display font-normal text-[40px] md:text-[72px] py-1 flex items-center" data-id="element-295">
              :
            </div>
            <div className="bg-bg-card w-[70px] h-[80px] md:w-[90px] md:h-[100px] flex flex-col items-center justify-center rounded-[12px]" data-id="element-296">
              <span className="font-display font-normal text-[40px] md:text-[72px] leading-none" data-id="element-297">
                {seconds.toString().padStart(2, '0')}
              </span>
              <span className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1" data-id="element-298">
                seg
              </span>
            </div>
          </div>
          <p className="font-sans text-[14px] md:text-[15px] text-txt-primary opacity-70" data-id="element-299">
            Después sube. No vuelve a este precio.
          </p>
        </div>

        <FinalCTAOffers data-id="element-300" />

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[13px] md:text-[14px] text-txt-primary opacity-80" data-id="element-301">
          <span className="flex items-center gap-2" data-id="element-302">
            <Lock size={16} data-id="element-303" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-304">
            <Clock size={16} data-id="element-305" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-306">
            <ShieldCheck size={16} data-id="element-307" /> Garantía 15 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-308">
            <CreditCard size={16} data-id="element-309" /> Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-brandOrange/30 py-12 px-6" data-id="element-310">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-311">
        <div data-id="element-312">
          <h2 className="font-display font-normal text-[28px] text-brandOrange mb-1" data-id="element-313">
            ✂️ MEGAPACK BARBERO PRO™
          </h2>
          <p className="font-sans font-medium text-[14px] text-txt-primary opacity-60" data-id="element-314">
            by CENTER SHOP DIGITAL
          </p>
        </div>

        <p className="font-sans text-[14px] text-txt-primary opacity-60 max-w-md mx-auto" data-id="element-315">
          El sistema de publicidad y captación número 1 para barberos en
          Latinoamérica. Porque llenar la agenda no debería depender de que te
          vuelvas influencer.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 font-sans text-[14px] text-txt-primary opacity-70 pt-4" data-id="element-316">
          <a href="mailto:soportecentershop95@gmail.com" className="hover:text-brandOrange transition-colors" data-id="element-317">
            📧 soportecentershop95@gmail.com
          </a>
          <a href="#" className="hover:text-brandOrange transition-colors" data-id="element-318">
            📲 @centershop.digital
          </a>
          <a href="#" className="hover:text-brandOrange transition-colors" data-id="element-319">
            🌐 www.centershop.store
          </a>
        </div>

        <div className="pt-8 border-t border-line space-y-3" data-id="element-320">
          <p className="font-sans text-[12px] text-[#888888]" data-id="element-321">
            © 2025 Center Shop Digital. Todos los derechos reservados.
          </p>
          <p className="space-x-4 font-sans text-[12px] text-[#888888]" data-id="element-322">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-323">
              Términos y condiciones
            </a>
            <span data-id="element-324">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-325">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};